var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubbleGroupChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "27px",
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bubble-group-chat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Event",
    transform: "translate(-330.000000, -76.000000)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bubble-group-chat",
    transform: "translate(330.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bubble-chat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1280469,19.8481055 C31.0270312,15.7807031 30.5838867,10.2081445 26.6242383,6.57820312 C24.8150391,4.91970703 22.5086133,3.88722656 20.0171484,3.59888672 C20.0016211,3.57978516 19.9857422,3.56085937 19.9683398,3.54275391 C17.8008984,1.29128906 14.6869922,-2.84217094e-14 11.4250781,-2.84217094e-14 C5.21771484,-2.84217094e-14 -5.68434189e-14,4.62498047 -5.68434189e-14,10.546875 C-5.68434189e-14,12.6231445 0.644941406,14.6135156 1.87007812,16.3324805 L0.158613281,21.7058789 C0.0510351562,22.0436133 0.156855469,22.4128125 0.426914062,22.6423242 C0.697441406,22.8722461 1.0790625,22.9164258 1.39435547,22.7560547 L6.5990625,20.1095508 C7.66792969,20.5698047 8.80136719,20.8717969 9.97511719,21.0091992 C12.2392969,23.3902148 15.3700195,24.609375 18.5730469,24.609375 C20.2380469,24.609375 21.8970117,24.2700586 23.3988281,23.6251172 L28.6037695,26.2717383 C28.7298047,26.3358398 28.8662695,26.3671875 29.0019141,26.3671875 C29.5950586,26.3671875 30.0202734,25.7891602 29.8395117,25.2215039 L28.1280469,19.8481055 Z M6.95378906,18.3410742 C6.70763672,18.2241797 6.42128906,18.2280469 6.17841797,18.3515625 L2.47136719,20.2365234 L3.68191406,16.4357812 C3.77003906,16.159043 3.71583984,15.8566992 3.53701172,15.6278906 C2.37298828,14.1378516 1.75769531,12.380918 1.75769531,10.546875 C1.75769531,5.70058594 6.09445312,1.7578125 11.4250781,1.7578125 C13.5717187,1.7578125 15.6382617,2.40814453 17.3145703,3.57925781 C11.6691797,4.14691406 7.14796875,8.55632812 7.14796875,14.0625 C7.14796875,15.7750781 7.58695312,17.4237891 8.41458984,18.9009375 C7.91349609,18.7516992 7.42546875,18.5650781 6.95378906,18.3410742 Z M23.819707,21.8671289 C23.5803516,21.7454297 23.2937695,21.7381055 23.0443359,21.8566992 C21.6741211,22.5075586 20.1280078,22.8515625 18.5730469,22.8515625 C13.2424219,22.8515625 8.90566406,18.9087891 8.90566406,14.0625 C8.90566406,9.21621094 13.2424219,5.2734375 18.5730469,5.2734375 C23.9036719,5.2734375 28.2404297,9.21621094 28.2404297,14.0625 C28.2404297,15.896543 27.6251367,17.6534766 26.4610547,19.143457 C26.2822852,19.3722656 26.2280859,19.6746094 26.3161523,19.9513477 L27.5266992,23.7520898 L23.819707,21.8671289 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 14.9990625,
    cy: 14.0625,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 18.5145117,
    cy: 14.0625,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillRule: "nonzero",
    cx: 22.0299023,
    cy: 14.0625,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleGroupChat);
export default __webpack_public_path__ + "static/media/bubble-group-chat.c40f53b9383c5f132a1477b6f3d37182.svg";
export { ForwardRef as ReactComponent };